<template>
    <div class="print-page">
        <h1>0～6岁儿童心理行为发育档案</h1>
        <hr/>
        <div class="d-flex justify-center">
            <h2 class="size-24">编号</h2>
            <input class="squ ml-ns" type="text" v-for="it in 17"/>
        </div>
        <br/>
        <br/>
        <br/>
        <br/>
        <div class="d-block" style="width: 80%; margin: auto; font-size: 18px; font-weight: bold;">
            <div class="d-flex justify-center">
                基层医疗机构
                <input class="d-flex-item line" type="text"/>
                省
                <input class="d-flex-item line" type="text"/>
                市（州）
                <input class="d-flex-item line" type="text"/>
                县（市、区）
            </div>
            <div class="d-flex justify-center mt-sm">
                <input class="d-flex-item line" type="text"/>
                乡（镇、社区）
                <input class="d-flex-item line" type="text"/>
            </div>
        </div>
        <br/>
        <br/>
        <div class="d-block" style="width: 80%; margin: auto; font-size: 18px; font-weight: bold;">
            <div class="d-flex justify-center">
                县级医疗机构
                <input class="d-flex-item line" type="text"/>
                省
                <input class="d-flex-item line" type="text"/>
                市（州）
                <input class="d-flex-item line" type="text"/>
                县（市、区）
            </div>
            <div class="d-flex justify-center mt-sm">
                <input class="d-flex-item line" type="text"/>
                乡（镇、社区）
                <input class="d-flex-item line" type="text"/>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    export default {
        props: {
            user: Object,
        },
        data() {
            return {}
        },
        async beforeDestroy() {},
        async created() {
            console.log('this.fayudangan---------->', this.user);
        },
        async mounted() {},
        methods: {
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/prints/fayudangan.vue